import { A4uHelpOutline as IconComponent } from '@adobe/react-spectrum-workflow/dist/HelpOutline.js';
import { Icon } from '@adobe/react-spectrum/Icon';
import React from 'react';
export default function HelpOutline(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}